const Partner = ({img1, img2, title, desc}) => {
    return (
        <div className="partner">
            <img className="partner-img" src={img1} alt="Partner" />
            <div className="details">
                <h5>{title}</h5>
                <p>{desc}</p>
            </div>
            <img className="logo" src={img2} alt="Partnership" />
        </div>
    )
}

export default Partner;